export default __webpack_public_path__ + "static/media/1 copy.9fd747d5.jpg";